import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";
import type { User } from "firebase/auth";
import ApiInterface from "./api-interface";
import { API_HTTP, resumeAnalyzerApiEndpoints } from "./endpoints";
import type {
	UserDetails,
	UserDetailsApiResponse
} from "../../DataModels/DataModels";

const FIVE_MINUTES_DURATION_IN_MS = 5 * 60 * 1000;

export const useUserDetails = () => {
	const authContext = useContext(AuthContext);
	const user: User | null = authContext?.user as User;

	const userDetailsQuery = useQuery<UserDetails>({
		queryKey: ["user", user?.uid, "details"],
		queryFn: async (): Promise<UserDetailsApiResponse> => {
			if (!user?.uid) throw new Error("User not authenticated");
			const apiClient = new ApiInterface(API_HTTP.resumeAnalyzer, user);
			const res = await apiClient.get(resumeAnalyzerApiEndpoints.user);
			console.log(res);
			return res;
		},
		enabled: !!user?.uid,
		staleTime: FIVE_MINUTES_DURATION_IN_MS
	});

	return {
		userDetails: userDetailsQuery.data,
		isLoading: userDetailsQuery.isLoading
	};
};
